import ArrowIcon from '../ui/icons/arrow-icon';
import NextLink from '../next-link';
import { useLocale } from 'next-intl';

const HomeTitle = ({
  title,
  link,
  linkTitle = '',
  swiper,
  parentClassName = '',
  linkClassName = '',
}) => {
  const locale = useLocale();

  return (
    <div className={`flex items-center justify-between ${parentClassName}`}>
      <div className='flex items-center gap-15'>
        <h2 className='text-sm leading-6.5 font-bold sm:text-base md:text-lg'>
          {title}
        </h2>
        {swiper ? (
          <div className='flex items-center gap-2.5 rtl:flex-row-reverse'>
            <button
              onClick={() => swiper?.slideNext()}
              aria-label={locale === 'en' ? 'Next' : 'التالي'}
              className='hidden size-9 cursor-pointer items-center justify-center rounded-full bg-black/20 hover:bg-black/40 max-md:size-7 lg:flex'
            >
              <ArrowIcon className='size-2.5 rotate-90 text-white' />
            </button>
            <button
              onClick={() => swiper?.slidePrev()}
              aria-label={locale === 'en' ? 'Previous' : 'السابق'}
              className='hidden size-9 cursor-pointer items-center justify-center rounded-full bg-black/20 hover:bg-black/40 max-md:size-7 lg:flex'
            >
              <ArrowIcon className='size-2.5 -rotate-90 text-white' />
            </button>
          </div>
        ) : null}
      </div>
      {link && (
        <NextLink
          href={link}
          className={`font-bold underline hover:underline max-lg:text-sm max-md:underline max-md:hover:no-underline max-sm:text-[10px] lg:text-[15px] ${linkClassName}`}
        >
          {linkTitle}
        </NextLink>
      )}
    </div>
  );
};

export default HomeTitle;
